module.exports = __webpack_public_path__ + "topLongLogo.03e9f936.png";